import { render, staticRenderFns } from "./DoctorInfoItem.vue?vue&type=template&id=4decdbe2&scoped=true"
import script from "./DoctorInfoItem.vue?vue&type=script&lang=js"
export * from "./DoctorInfoItem.vue?vue&type=script&lang=js"
import style0 from "./DoctorInfoItem.vue?vue&type=style&index=0&id=4decdbe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4decdbe2",
  null
  
)

export default component.exports